import {
  Button,
  Input,
  Textarea,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const slugify = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export default function CenterUpdate() {
  const { slug: routeSlug } = useParams();
  const [loader, setLoader] = useState(false);
  const [postLoader, setPostLoader] = useState(false);
  const [center, setCenter] = useState({});
  const navigate = useNavigate();

  //dialogue
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(!open);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(!open2);
  const [open3, setOpen3] = React.useState(false);
  const handleOpen3 = () => setOpen3(!open3);

  //data states
  const [selectedCenterImg, setSelectedCenterImg] = useState("");
  const [selectedFloorMap, setSelectedFloorMap] = useState("");

  const [slug, setSlug] = useState("");
  const [slugEdited, setSlugEdited] = useState(false);

  const [description, setDescription] = useState("");

  const [operationalHours, setOperationalHours] = useState("");
  const [whatsappHotline, setWhatsappHotline] = useState("");

  const [information, setInformation] = useState("");
  const [informations, setInformations] = useState([]);

  const [condition, setCondition] = useState("");
  const [conditions, setConditions] = useState([]);

  const [treatment, setTreatment] = useState("");
  const [treatments, setTreatments] = useState([]);

  const handleSlugChange = (e) => {
    setSlugEdited(true);
    setSlug(slugify(e.target.value));
  };

  //react quil

  const [editorValue, seteditorValue] = useState("");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video", "code-block"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  // informations add remove functions
  const addInformations = () => {
    const newInformations = [...informations, { information }];
    setInformations(newInformations);
    setInformation("");
  };
  const removeInformation = (index) => {
    const updatedInformations = [...informations];
    updatedInformations.splice(index, 1);
    setInformations(updatedInformations);
  };
  // conditions add remove functions
  const addConditions = () => {
    const newConditions = [...conditions, { condition }];
    setConditions(newConditions);
    setCondition("");
  };
  const removeCondition = (index) => {
    const updatedConditions = [...conditions];
    updatedConditions.splice(index, 1);
    setConditions(updatedConditions);
  };
  // treatments add remove functions
  const addTreatments = () => {
    const newTreatments = [...treatments, { treatment }];
    setTreatments(newTreatments);
    setTreatment("");
  };
  const removeTreatment = (index) => {
    const updatedTreatments = [...treatments];
    updatedTreatments.splice(index, 1);
    setTreatments(updatedTreatments);
  };

  //get center
  useEffect(() => {
    setLoader(true);
    fetch(`https://api.discoverinternationalmedicalservice.com/api/get/centers/${routeSlug}`)
      .then((res) => res.json())
      .then((data) => {
        const found = data?.response?.data;
        setCenter(found);
        setSlug(found?.slug || "");
        setDescription(found?.description || "");
        setInformations(found?.informations || []);
        setConditions(found?.conditions || []);
        setTreatments(found?.treatments || []);
        seteditorValue(found?.content || "");
        setOperationalHours(found?.operational_hours || "");
        setWhatsappHotline(found?.whatsapp_hotline || "");
        setLoader(false);
      });
  }, [routeSlug]);

  //add clinic and centers
  const handleUpdateClinic = (e) => {
    setPostLoader(true);
    e.preventDefault();
    const name = e.target.name.value;
    const location = e.target.location.value;

    const formData = new FormData();
    formData.append("cover_photo", selectedCenterImg);
    formData.append("content", editorValue);
    formData.append("name", name);
    formData.append("location", location);
    formData.append("slug", slug);
    formData.append("description", description);
    formData.append("informations", JSON.stringify(informations));
    formData.append("conditions", JSON.stringify(conditions));
    formData.append("treatments", JSON.stringify(treatments));
    if (selectedFloorMap) {
      formData.append("floor_map", selectedFloorMap);
    }
    formData.append("operational_hours", operationalHours);
    formData.append("whatsapp_hotline", whatsappHotline);

    fetch(`https://api.discoverinternationalmedicalservice.com/api/update/center/${center.id}`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.status === 200) {
          setPostLoader(false);
          e.target.reset();
          toast.success("Centers updated successfully!");
          navigate("/home/centers-list");
        } else {
          setPostLoader(false);
          toast.error(data?.msg);
        }
      })
      .catch((e) => console.error(e));
  };
  return (
    <div className="mx-5 md:container md:mx-auto py-10">
      {loader ? (
        <Loader />
      ) : (
        <form onSubmit={handleUpdateClinic} className="bg-white p-5">
          <p className="text-2xl font-semibold">Update Center</p>
          <hr className="my-5" />
          <div className="flex items-start gap-5">
            <img
              src={center?.cover_photo}
              className="h-[250px]"
              alt="center_cover_photo"
            />

            <div>
              <div className="flex items-center">
                <input
                  type="file"
                  id="custom-input"
                  onChange={(e) => setSelectedCenterImg(e.target.files[0])}
                  hidden
                />
                <label
                  htmlFor="custom-input"
                  className="block text-sm text-slate-500 mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-blue duration-300 ease-linear text-white cursor-pointer"
                >
                  Choose file
                </label>
                <label className="text-sm text-slate-500">
                  {selectedCenterImg?.name
                    ? selectedCenterImg?.name
                    : "No File Chosen"}
                </label>
              </div>
              <p className="text-red-400 text-sm mt-2.5">
                Image Ratio - 1200*628. Image size not more than 500kb
              </p>
            </div>
          </div>

          <div className="grid gap-4 lg:grid-cols-2 my-4">
            <Input label="Enter Name" name="name" defaultValue={center?.name} />
            <Input
              label="Enter Location"
              name="location"
              defaultValue={center?.location}
            />
            <div>
              <Input label="Enter Slug" name="slug" value={slug} onChange={handleSlugChange} />
              <p className="text-xs text-slate-500 mt-1">
                Used in the page URL — edit only if needed.
              </p>
            </div>
            {/* multiple information  */}
            <div className="flex items-center gap-5">
              <div className="relative flex w-full">
                <Input
                  value={information}
                  type="text"
                  label="Enter Informations"
                  onChange={(e) => setInformation(e.target.value)}
                />
                <Button
                  size="sm"
                  onClick={addInformations}
                  className="!absolute right-1 top-1 rounded bg-blue"
                  disabled={information === ""}
                >
                  Add
                </Button>
              </div>
              <div className="relative">
                <Button
                  onClick={handleOpen}
                  size="sm"
                  className="bg-white text-blue border border-blue"
                >
                  View
                </Button>
                {informations.length > 0 && (
                  <div className="h-3 w-3 rounded-full bg-green-400 absolute -top-1 -right-1 shadow-xl"></div>
                )}
                <Dialog
                  open={open}
                  handler={handleOpen}
                  className="overflow-y-auto h-[90%]"
                >
                  <DialogHeader>Informations</DialogHeader>
                  <DialogBody divider>
                    {informations.length > 0 ? (
                      <div className="flex flex-col gap-4">
                        {informations.map((c, i) => (
                          <div key={i} className="flex justify-between">
                            <ul className="w-5/6 list-disc ml-4">
                              <li className="text-xl text-justify">
                                {c.information}
                              </li>
                            </ul>
                            <div className="w-1/6 flex justify-center">
                              {" "}
                              <AiOutlineDelete
                                onClick={() => removeInformation(i)}
                                className="text-red-500 text-3xl cursor-pointer"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="py-5 font-semibold text-red-500">
                        Enter Something!
                      </p>
                    )}
                  </DialogBody>
                  <DialogFooter>
                    <Button
                      variant="text"
                      color="red"
                      size="sm"
                      onClick={handleOpen}
                      className="mr-1"
                    >
                      <span>Close</span>
                    </Button>
                  </DialogFooter>
                </Dialog>
              </div>
            </div>
            {/* multiple condition */}
            <div className="flex items-center gap-5">
              <div className="relative flex w-full">
                <Input
                  value={condition}
                  type="text"
                  label="Enter Condition"
                  onChange={(e) => setCondition(e.target.value)}
                />
                <Button
                  size="sm"
                  onClick={addConditions}
                  className="!absolute right-1 top-1 rounded bg-blue"
                  disabled={condition === ""}
                >
                  Add
                </Button>
              </div>
              <div className="relative">
                <Button
                  onClick={handleOpen2}
                  size="sm"
                  className="bg-white text-blue border border-blue"
                >
                  View
                </Button>
                {conditions.length > 0 && (
                  <div className="h-3 w-3 rounded-full bg-green-400 absolute -top-1 -right-1 shadow-xl"></div>
                )}
                <Dialog
                  open={open2}
                  handler={handleOpen2}
                  className="overflow-auto h-[90%]"
                >
                  <DialogHeader>Conditions</DialogHeader>
                  <DialogBody divider>
                    {conditions.length > 0 ? (
                      <div className="flex flex-col gap-4">
                        {conditions.map((c, i) => (
                          <div key={i} className="flex justify-between">
                            <ul className="w-5/6 list-disc ml-4">
                              <li className="text-xl text-justify">
                                {c.condition}
                              </li>
                            </ul>
                            <div className="w-1/6 flex justify-center">
                              {" "}
                              <AiOutlineDelete
                                onClick={() => removeCondition(i)}
                                className="text-red-500 text-3xl cursor-pointer"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="py-5 font-semibold text-red-500">
                        Enter Something!
                      </p>
                    )}
                  </DialogBody>
                  <DialogFooter>
                    <Button
                      variant="text"
                      color="red"
                      size="sm"
                      onClick={handleOpen2}
                      className="mr-1"
                    >
                      <span>Close</span>
                    </Button>
                  </DialogFooter>
                </Dialog>
              </div>
            </div>
            {/* multiple treatment */}
            <div className="flex items-center gap-5">
              <div className="relative flex w-full">
                <Input
                  value={treatment}
                  type="text"
                  label="Enter Treatment"
                  onChange={(e) => setTreatment(e.target.value)}
                />
                <Button
                  size="sm"
                  onClick={addTreatments}
                  className="!absolute right-1 top-1 rounded bg-blue"
                  disabled={treatment === ""}
                >
                  Add
                </Button>
              </div>
              <div className="relative">
                <Button
                  onClick={handleOpen3}
                  size="sm"
                  className="bg-white text-blue border border-blue"
                >
                  View
                </Button>
                {treatments.length > 0 && (
                  <div className="h-3 w-3 rounded-full bg-green-400 absolute -top-1 -right-1 shadow-xl"></div>
                )}
                <Dialog
                  open={open3}
                  handler={handleOpen3}
                  className="overflow-auto h-[90%]"
                >
                  <DialogHeader>Treatments</DialogHeader>
                  <DialogBody divider>
                    {treatments.length > 0 ? (
                      <div className="flex flex-col gap-4">
                        {treatments.map((c, i) => (
                          <div key={i} className="flex justify-between">
                            <ul className="w-5/6 list-disc ml-4">
                              <li className="text-xl text-justify">
                                {c.treatment}
                              </li>
                            </ul>
                            <div className="w-1/6 flex justify-center">
                              {" "}
                              <AiOutlineDelete
                                onClick={() => removeTreatment(i)}
                                className="text-red-500 text-3xl cursor-pointer"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="py-5 font-semibold text-red-500">
                        Enter Something!
                      </p>
                    )}
                  </DialogBody>
                  <DialogFooter>
                    <Button
                      variant="text"
                      color="red"
                      size="sm"
                      onClick={handleOpen3}
                      className="mr-1"
                    >
                      <span>Close</span>
                    </Button>
                  </DialogFooter>
                </Dialog>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2">
            <Textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              label="Enter Short Description"
              rows={8}
              name="description"
            />
          </div>
          <div className="mt-4">
            <label htmlFor="" className="text-red">
              <span className="font-semibold">Long Description</span>
            </label>
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              value={editorValue}
              onChange={seteditorValue}
              className="my-2.5"
            />
          </div>
          <div className="mt-6">
            <p className="text-xl font-semibold">Office Contact Details</p>
            <p className="text-xs text-slate-500 mb-3">
              Shown on the center's page so visitors can find the exact office, know when it's open, and reach a hotline directly.
            </p>
            <div className="grid gap-4 lg:grid-cols-2">
              <div className="flex items-start gap-5">
                {center?.floor_map && (
                  <img
                    src={center.floor_map}
                    className="h-[100px]"
                    alt="center_floor_map"
                  />
                )}
                <div>
                  <div className="flex items-center">
                    <input
                      type="file"
                      id="floor-map-input"
                      onChange={(e) => setSelectedFloorMap(e.target.files[0])}
                      hidden
                    />
                    <label
                      htmlFor="floor-map-input"
                      className="block text-sm text-slate-500 mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-blue duration-300 ease-linear text-white cursor-pointer"
                    >
                      Choose Floor Map
                    </label>
                    <label className="text-sm text-slate-500">
                      {selectedFloorMap?.name ? selectedFloorMap.name : "No File Chosen"}
                    </label>
                  </div>
                  <p className="text-xs text-slate-500 mt-1">
                    A photo or scan of the office floor map, optional.
                  </p>
                </div>
              </div>
              <div>
                <Input
                  label="WhatsApp Hotline"
                  name="whatsapp_hotline"
                  value={whatsappHotline}
                  onChange={(e) => setWhatsappHotline(e.target.value)}
                />
                <p className="text-xs text-slate-500 mt-1">e.g. +66 12 345 6789</p>
              </div>
              <div className="lg:col-span-2">
                <Textarea
                  label="Operational Hours"
                  name="operational_hours"
                  value={operationalHours}
                  onChange={(e) => setOperationalHours(e.target.value)}
                />
                <p className="text-xs text-slate-500 mt-1">
                  e.g. "Mon-Fri: 8:00 AM - 8:00 PM, Sat-Sun: 9:00 AM - 5:00 PM"
                </p>
              </div>
            </div>
          </div>
          <Button className="bg-blue mt-6" type="submit">
            {postLoader ? "Loading" : "Update Center"}
          </Button>
        </form>
      )}
    </div>
  );
}
